import React, { useEffect } from 'react';
import MessageBubble from './MessageBubble';



function ChatBody({ messages, isThinking }) {

  useEffect(() => {
    const chatBody = document.querySelector('.chat-body');
    if (chatBody) {
      chatBody.scrollTop = chatBody.scrollHeight;
      console.log('Scrolled to bottom, scrollHeight:', chatBody.scrollHeight);
    }
  }, [messages, isThinking]);

  return (
    <div className="chat-body overflow-y-auto p-4 h-full">
      {messages.map((msg) => (
        <div
          key={msg.id} // 使用唯一 ID 作为 key
          className={`flex mb-2 ${msg.isUser ? 'justify-end' : 'justify-start'}`}
        >
          <MessageBubble message={msg.message} isUser={msg.isUser} />
        </div>
      ))}

      {/* {isThinking && currentStream && (
        <div className="flex justify-start mb-2">
          <MessageBubble message={currentStream.trim()} isUser={false} />
        </div>
      )} */}

      {isThinking && (
        <div className="flex justify-start mb-2">
          <div className="bg-gray-300 text-gray-800 rounded-lg p-2 flex items-center w-28"> {/* 尝试 w-32，可以根据需要调整 */}
            <span>思考中</span>
            <span className="dot-flashing ml-4"></span>
          </div>
        </div>
      )}

    </div>
  );
}

export default ChatBody;